<template>
  <div>
    <top-message />
    <div class="content">
      <div class="top">登录日志</div>
      <div class="from">
        <el-form ref="form" :model="form" label-width="100px" :inline="true">
          <el-form-item label="登录用户名">
            <el-input @change="search" v-model="form.loginName" clearable></el-input>
          </el-form-item>
          <el-form-item label="关联企业名称">
            <el-input @change="search" v-model="form.enterpriseName" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="queryInfo">查询</el-button>
            <!-- <el-button icon="el-icon-upload2" @click="expertExcel">导出</el-button>
            <el-button icon="el-icon-upload2" @click="uploadExcel">批量上报</el-button>-->
          </el-form-item>
        </el-form>
      </div>
      <div class="tab">
        <el-table :data="applyProList" style="width: 100%">
          <el-table-column align="center" prop="loginName" label="登录用户名" width="250">
            <template slot-scope="scope">
              <div>
                <div>{{scope.row.loginName}}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="enterpriseName" label="关联企业名称 " width="180">
            <template slot-scope="scope">{{scope.row.enterpriseName}}</template>
          </el-table-column>
          <el-table-column align="center" prop="enterpriseCode" label="关联企业统一社会信用代码">
            <template slot-scope="scope">{{scope.row.enterpriseCode}}</template>
          </el-table-column>
          <el-table-column align="center" prop="loginTime" label="登录时间">
            <template slot-scope="scope">{{scope.row.loginTime}}</template>
          </el-table-column>
          <el-table-column align="center" prop="loginIp" label="登录IP">
            <template slot-scope="scope">{{scope.row.loginIp}}</template>
          </el-table-column>
          <el-table-column align="center" prop="phone" label="登录验证手机号">
            <template slot-scope="scope">{{scope.row.phone}}</template>
          </el-table-column>
          <el-table-column align="center" prop="status" label="登录状态">
            <template slot-scope="scope">{{scope.row.status}}</template>
          </el-table-column>
          <!-- <el-table-column label="操作">
            <template slot-scope="{ row }">
              <el-button @click="detailLook(row)" type="text">详情</el-button>
              <span>|</span>
              <el-button
                :disabled="selectedItems.id == row.id"
                v-if="row.auditStatus=='1'"
                @click="agreeUpload(row)"
                type="text"
              >协议上报</el-button>
              <el-button v-if="row.auditStatus=='4'" @click="agreeRevoke(row)" type="text">协议撤销</el-button>
            </template>
          </el-table-column>-->
        </el-table>
        <div class="block">
          <el-pagination
            @current-change="handleCurrentChange"
            :page-size="this.form.pageSize"
            layout="total, prev, pager, next"
            :total="this.total"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TopMessage from "@/components/TopMessage";
import { loginList } from "@/api/loglistinfo";

export default {
  components: { TopMessage },
  data() {
    return {
      form: {
        loginName: "",
        enterpriseName: "",
        page: 1,
        pageSize: 10
      },
      applyProList: [],
      total: 0
    };
  },
  created() {
    this.getloginListList();
  },
  methods: {
    // 查询
    queryInfo() {
      this.getloginListList();
    },
    search() {
      this.getloginListList();
    },
    async getloginListList() {
      const res = await loginList(this.form);
      this.applyProList = res.data.data.list;
      this.total = res.data.data.total;
      // console.log(res, "rrrrrr");
    },

    handleCurrentChange(val) {
      this.form.page = val;
      this.getloginListList();
    }
    // expertExcel() {
    //   // if (this.form.applyTime[0] == undefined) {
    //   //   this.form.applyTime[0] = ''
    //   // }
    //   // if (this.form.applyTime[1] == undefined) {
    //   //   this.form.applyTime[1] = ''
    //   // }
    //   const xhr = new XMLHttpRequest();
    //   xhr.open(
    //     "post",
    //     this.baseUrl + "/api/credit/excel/expertApplyProList",
    //     true
    //   ); // get、post都可
    //   xhr.responseType = "blob"; // 转换流
    //   xhr.setRequestHeader("token", sessionStorage.getItem("token")); // token键值对
    //   xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
    //   xhr.onload = function() {
    //     if (this.status === 200) {
    //       const blob = this.response;
    //       const fileName = "已申请特色产品企业统计表.xls";
    //       if (window.navigator.msSaveOrOpenBlob) {
    //         navigator.msSaveBlob(blob, fileName);
    //       } else {
    //         const a = document.createElement("a");
    //         const url = window.URL.createObjectURL(blob);
    //         a.href = url;
    //         a.download = fileName;
    //         document.body.appendChild(a);
    //         a.click();
    //         window.URL.revokeObjectURL(url);
    //       }
    //     }
    //   };
    //   xhr.send(
    //     "deptName=" +
    //       this.form.deptName +
    //       "&appDeptId=" +
    //       this.form.appDeptId +
    //       "&bankCode=" +
    //       this.form.bankCode +
    //       "&startTime=" +
    //       this.form.startTime +
    //       "&endTime=" +
    //       this.form.endTime +
    //       "&pageSize=" +
    //       this.form.pageSize +
    //       "&page=" +
    //       this.form.page +
    //       "&proName=" +
    //       this.form.product
    //   );
    // }
  }
};
</script>
<style lang='less' scoped>
.content {
  min-height: 894px;
  margin-top: 10px;
  background-color: #fff;
  border-radius: 8px;
  padding-top: 10px;
  padding-bottom: 20px;
  .top {
    height: 30px;
    border-left: 8px solid #2981ee;
    padding-left: 38px;
    box-sizing: border-box;
    font-size: 22px;
    font-family: Alibaba PuHuiTi;
    font-weight: 500;
    color: #2981ee;
    line-height: 30px;
  }
  .from {
    margin-top: 37px;
    margin-left: 38px;
  }
  .dowm {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    padding-right: 40px;
    box-sizing: border-box;
    /deep/ .el-button {
      width: 157px;
      height: 40px;
      background: #2981ee;
      border-radius: 6px;
      color: #fff;
    }
  }
  .tab {
    box-sizing: border-box;
    margin-top: 15px;
    min-height: 700px;
    .block {
      margin-top: 20px;
      display: flex;
      justify-content: center;
    }
    /deep/ .el-table th {
      background: #f3f4f9;
    }
  }
}
</style> 